import gql from "graphql-tag";

export const CREATE_CRM_STEP = gql`
  mutation AddCrmStep($data: CrmStepDataInput) {
    addCrmStep(data: $data) {
      id type order parentId branchKey config isAutomatic senderOverride
    }
  }
`;

export const UPDATE_CRM_STEP = gql`
  mutation UpdateCrmStep($where: CrmStepWhereInput, $data: CrmStepDataInput) {
    updateCrmStep(where: $where, data: $data) { id }
  }
`;

export const DELETE_CRM_STEP = gql`
  mutation DeleteCrmStep($where: CrmStepWhereInput) {
    deleteCrmStep(where: $where) { id }
  }
`;

const crmSteps = { CREATE_CRM_STEP, UPDATE_CRM_STEP, DELETE_CRM_STEP };
export default crmSteps;
